import { useLocation, useNavigate } from 'react-router-dom';

import { List, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import PopoverUi from '@mui/material/Popover';
import {
  Autorenew,
  Block as BlockIcon,
  Edit,
  EditOutlined as EditOutlinedIcon,
  MoreVert as MoreVertIcon,
  Timeline as TimelineIcon,
} from '@mui/icons-material';

import {
  CADASTRO_FIGURANTE,
  CADASTRO_FIGURANTE_ANIMAL,
  CADASTRO_FIGURANTE_FISCAL,
  CADASTRO_FIGURANTE_VEICULO,
} from 'commons/constants/permissions';
import { GESTAO_FIGURACAO, TIME_COMFIGURA } from 'commons/constants/profiles';
import { useUserData } from 'commons/contexts';
import { SRC_TYPES } from '../@types';
import { useFigurantCard } from '../hooks/useFigurantCard';
import { CustomIconButton } from './styles';
import { KeyTypeFigurant, StatusFigurant } from 'models';
import { useActionPopover } from '../hooks/useActionPopover';

export const Popover = ({
  item,
  type,
  handleStatusFigurant,
  selected = false,
  src,
}: {
  src?: string;
  item: StatusFigurant;
  type: KeyTypeFigurant;
  handleStatusFigurant?: (item: StatusFigurant | null) => void;
  selected?: boolean;
}) => {
  const { hasProfiles, hasResource } = useUserData();
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const { cardType } = useFigurantCard({ item, type });
  const { anchorEl, handleClosePopover, handleOpenPopover } = useActionPopover();

  const openPopover = Boolean(anchorEl);

  const showChangeAgency = (type === '1' || type === '2') && hasProfiles([GESTAO_FIGURACAO, TIME_COMFIGURA]);
  const showEdit = hasResource([
    CADASTRO_FIGURANTE,
    CADASTRO_FIGURANTE_FISCAL,
    CADASTRO_FIGURANTE_ANIMAL,
    CADASTRO_FIGURANTE_VEICULO,
  ]);
  const showBlock = hasProfiles([GESTAO_FIGURACAO, TIME_COMFIGURA]);

  return (
    <>
      <CustomIconButton data-testid="button-to-open-modal" onClick={handleOpenPopover}>
        <MoreVertIcon htmlColor={selected ? '#FFF' : ''} />
      </CustomIconButton>
      <PopoverUi
        open={openPopover}
        anchorEl={anchorEl}
        onClose={handleClosePopover}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        elevation={1}
        disableScrollLock
        data-testid="modal-wrapper"
      >
        <List data-testid="content-modal-opened">
          {src !== SRC_TYPES.CLIMBED && (
            <>
              {showEdit && (
                <ListItemButton
                  onClick={() =>
                    navigate(`/${cardType}/${item.id}/editar`, {
                      state: { entityType: item?.entityType, from: pathname },
                    })
                  }
                >
                  <ListItemIcon sx={{ minWidth: 40 }}>
                    <Edit sx={{ color: 'primary.dark' }} />
                  </ListItemIcon>
                  <ListItemText primary="Editar" sx={{ color: 'secondary.dark' }} />
                </ListItemButton>
              )}
              {showChangeAgency && (
                <ListItemButton onClick={event => console.log(event)}>
                  <ListItemIcon sx={{ minWidth: 40 }}>
                    <Autorenew sx={{ color: 'primary.dark' }} />
                  </ListItemIcon>
                  <ListItemText primary="Alterar agência" sx={{ color: 'secondary.dark' }} />
                </ListItemButton>
              )}
              {showBlock && (
                <ListItemButton onClick={() => handleStatusFigurant && handleStatusFigurant(item)}>
                  <ListItemIcon sx={{ minWidth: 40 }}>
                    <BlockIcon sx={{ color: 'primary.dark' }} />
                  </ListItemIcon>
                  <ListItemText
                    primary={item?.isActive ? 'Bloquear' : 'Desbloquear'}
                    sx={{ color: 'secondary.dark' }}
                  />
                </ListItemButton>
              )}
            </>
          )}
          {src === SRC_TYPES.CLIMBED && (
            <ListItemButton
              onClick={() =>
                navigate(`/${cardType}/${item.id}/editar`, { state: { entityType: item?.entityType, from: pathname } })
              }
            >
              <ListItemIcon sx={{ minWidth: 40 }}>
                <EditOutlinedIcon color="primary" />
              </ListItemIcon>
              <ListItemText primary="Editar" sx={{ color: 'primary' }} />
            </ListItemButton>
          )}

          {src === SRC_TYPES.SEARCH && (
            <ListItemButton onClick={() => navigate(`/ver-mais/${cardType}/${item.id}`)}>
              <ListItemIcon sx={{ minWidth: 40 }}>
                <TimelineIcon sx={{ color: 'primary.dark' }} />
              </ListItemIcon>
              <ListItemText primary="Histórico de figuração" />
            </ListItemButton>
          )}
        </List>
      </PopoverUi>
    </>
  );
};
